import type { ParagraphFeaturesIcons as ParagraphFeaturesIconsData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphFeaturesIcons.module.css";

/**
 * Layout 35 - `PARAGRAPH_FEATURES_ICONS_LAYOUT`: cechy z ikonami.
 *
 * Struktura:
 *   - Tytul H2 sekcji (name) - wysrodkowany
 *   - Grid 3 kolumny x 2 wiersze = 6 kart cech:
 *       - Ikona (Nucleo outline, klasa `nc-icon-outline {icon}`)
 *       - Nazwa (H3)
 *       - Opis (paragraph)
 *   - Puste karty (bez name i desc) sa filtrowane po backendzie.
 */
export function ParagraphFeaturesIcons({
  paragraph,
}: {
  paragraph: ParagraphFeaturesIconsData;
  t: ParagraphTranslations;
}) {
  const { name: title, features } = paragraph;
  const hasFeatures = Array.isArray(features) && features.length > 0;

  return (
    <section className={styles.section}>
      {title ? <h2 className={styles.title}>{title}</h2> : null}
      {hasFeatures ? (
        <div className={styles.grid}>
          {features.map((f, idx) => (
            <div key={idx} className={styles.card}>
              {f.icon ? (
                <div className={styles.icon} aria-hidden="true">
                  <i className={`nc-icon-outline ${f.icon}`} />
                </div>
              ) : null}
              {f.name ? <h3 className={styles.name}>{f.name}</h3> : null}
              {f.desc ? <p className={styles.desc}>{f.desc}</p> : null}
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
